import "./es.symbol.description-6025a604.js";
import "./es.object.assign-7e79fd7b.js";
import { c as l } from "./index-8b07dec9.js";
import e, { css as p } from "styled-components";
import "./es.array.filter-4e9c9996.js";
import "./es.array.concat-d1c9b847.js";
import "./es.object.from-entries-0d7a0e54.js";
import "./es.array.map-d821aaf5.js";
import "./es.object.entries-d2a19275.js";
import "./es.object.to-string-f55666a8.js";
import "./es.string.replace-f4cc3aea.js";
import "./es.array.is-array-7a29277f.js";
import "react";
import "./web.dom-collections.for-each-3020ed11.js";
import { g as _ } from "./getMetrics-953aa4f8.js";
import { Button as v } from "./button.js";
import { hTag as g } from "./hTag.js";
import { a as x } from "./index-5d0f31c6.js";
import { Image as h } from "./image.js";
import { jsxs as f, jsx as a } from "react/jsx-runtime";
import "./export-cdcbfb2b.js";
import "./to-string-92a62764.js";
import "./classof-21a3574e.js";
import "./object-create-9b6715a2.js";
import "./object-keys-719a5561.js";
import "./html-32ef1b46.js";
import "./object-get-own-property-names-external-2f8b4cc4.js";
import "./array-slice-79f93c56.js";
import "./define-built-in-accessor-26bc7b69.js";
import "./iterate-13ada9e5.js";
import "./array-iteration-759bfbfa.js";
import "./function-apply-4756dee6.js";
import "./create-property-f9780ed1.js";
import "./correct-is-regexp-logic-4465cd47.js";
import "./is-regexp-4c49b1c2.js";
import "./object-to-array-0474b7e7.js";
import "./object-set-prototype-of-7d7e5736.js";
import "./function-uncurry-this-clause-99074d1c.js";
import "./array-method-is-strict-e5a3c878.js";
import "./objectWithoutPropertiesLoose-2ffc4b6d.js";
import "./es.object.keys-9d66766f.js";
import "@ucl/shared-component-foundations";
import "./combineRefs-c9ad2c39.js";
import "./web.set-timeout-72b6430f.js";
import "./environment-ddee5959.js";
import "./validate-arguments-length-eb516e5b.js";
import "./es.array.some-0c761b6d.js";
import "./es.array.every-3d11adb5.js";
import "./useScroll.js";
import "./getTarget-19e0f923.js";
import "./useEventListener.js";
import "./isClient-2f5bedbd.js";
import "./useOverFlown.js";
import "./useResizeObserver.js";
import "./isApiSupported-66660265.js";
import "./useIsMounted.js";
import "./useSlots.js";
import "./createClass-57dcdeea.js";
import "./es.date.to-json-b76d522e.js";
import "./an-instance-6efcfd6c.js";
import "./check-correctness-of-iteration-7d57c70c.js";
import "./inherit-if-required-f068457b.js";
import "./set-species-5ede2ed0.js";
import "./es.string.iterator-5de8a61e.js";
import "@ucl/shared-icons";
import "./es.array.join-c1bca812.js";
import "./aspectRatio.js";
import "./species-constructor-00346775.js";
import "./es.string.trim-6e13db75.js";
import "./string-trim-14e37ad3.js";
import "./mediaDisclosureButton.js";
import "./es.parse-int-d7709701.js";
var W = /* @__PURE__ */ e.div.withConfig({
  displayName: "cardIllustration__Wrapper",
  componentId: "ru17wi-0"
})(["&.CardIllustration__Wrapper{", ";}"], function(i) {
  var r = i.theme, m = r.componentStyles, n = r.components.cardIllustration;
  return p(n.Wrapper, m);
}), N = /* @__PURE__ */ e.div.withConfig({
  displayName: "cardIllustration__ImageContainer",
  componentId: "ru17wi-1"
})(["&.CardIllustration__ImageContainer{", ";}"], function(i) {
  var r = i.theme.components.cardIllustration;
  return p(r.ImageContainer);
}), w = /* @__PURE__ */ e(g).withConfig({
  displayName: "cardIllustration__TitleWrapper",
  componentId: "ru17wi-2"
})(["&.CardIllustration__TitleWrapper{", ";}"], function(i) {
  var r = i.theme.components.cardIllustration;
  return p(r.TitleWrapper);
}), P = /* @__PURE__ */ e.div.withConfig({
  displayName: "cardIllustration__DescriptionWrapper",
  componentId: "ru17wi-3"
})(["&.CardIllustration__DescriptionWrapper{", ";}"], function(i) {
  var r = i.theme.components.cardIllustration;
  return p(r.DescriptionWrapper);
}), y = /* @__PURE__ */ e.div.withConfig({
  displayName: "cardIllustration__IconContainer",
  componentId: "ru17wi-4"
})(["&.CardIllustration__IconContainer{", ";}"], function(i) {
  var r = i.theme.components.cardIllustration;
  return p(r.IconContainer);
}), z = /* @__PURE__ */ e.div.withConfig({
  displayName: "cardIllustration__ButtonContainer",
  componentId: "ru17wi-5"
})(["&.CardIllustration__ButtonContainer{", ";}"], function(i) {
  var r = i.theme.components.cardIllustration;
  return p(r.ButtonContainer);
}), u = {
  xxSmall: "xxs",
  xSmall: "xs",
  small: "s",
  medium: "m",
  large: "l",
  xLarge: "xl",
  xxLarge: "xxl",
  xxs: "xxs",
  xs: "xs",
  s: "s",
  m: "m",
  l: "l",
  xl: "xl",
  xxl: "xxl"
}, Kr = function(r) {
  var m = r.mediaProps, n = r.titleProps, s = r.description, c = r.ctaProps, d = r.alignment, I = d === void 0 ? "center" : d, C = _({
    label: "CardIllustration"
  }), o = m.imageProp, t = m.iconProp;
  return /* @__PURE__ */ f(W, Object.assign({
    className: l(["CardIllustration", "CardIllustration__Wrapper", "CardIllustration__Wrapper--" + I + "Align"])
  }, C, {
    children: [o ? /* @__PURE__ */ a(N, {
      className: l(["CardIllustration__ImageContainer", "CardIllustration__ImageContainer--" + ((o == null ? void 0 : o.size) || "xxLarge")]),
      children: /* @__PURE__ */ a(h, {
        src: o == null ? void 0 : o.src,
        alt: o == null ? void 0 : o.alt,
        disclosureLinks: o == null ? void 0 : o.disclosureLinks,
        variant: "none"
      })
    }) : t != null && t.icon && typeof (t == null ? void 0 : t.icon) == "string" ? /* @__PURE__ */ a(x, {
      icon: t == null ? void 0 : t.icon,
      size: (t == null ? void 0 : t.size) && u[t.size],
      extended: !0
    }) : /* @__PURE__ */ a(y, {
      className: l(["CardIllustration__IconContainer", "CardIllustration__IconContainer--" + ((t == null ? void 0 : t.size) && u[t.size] || "l")]),
      children: t == null ? void 0 : t.icon
    }), /* @__PURE__ */ a(w, {
      as: (n == null ? void 0 : n.headingLevel) || "h1",
      className: l(["CardIllustration__TitleWrapper", "CardIllustration__TitleWrapper--" + ((n == null ? void 0 : n.size) || "xLarge")]),
      children: n == null ? void 0 : n.title
    }), s && /* @__PURE__ */ a(P, {
      className: l(["CardIllustration__DescriptionWrapper"]),
      children: s
    }), c && /* @__PURE__ */ a(z, {
      className: l(["CardIllustration__ButtonContainer"]),
      children: /* @__PURE__ */ a(v, Object.assign({}, c))
    })]
  }));
};
export {
  Kr as CardIllustration
};
